import { Icon as CogsIcon } from '@cognite/cogs.js';
import React from 'react';

export function Icon(props: React.ComponentProps<typeof CogsIcon>) {
  return <CogsIcon {...props} />;
}
